import { render, staticRenderFns } from "./priceGroup.vue?vue&type=template&id=34d4d712&scoped=true"
import script from "./priceGroup.vue?vue&type=script&lang=js"
export * from "./priceGroup.vue?vue&type=script&lang=js"
import style0 from "./priceGroup.vue?vue&type=style&index=0&id=34d4d712&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d4d712",
  null
  
)

export default component.exports